import { CircularProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { blackBackArrowImage } from "../../assets";
import { invokeApi } from "../../bl_libs/invokeApi";
import { useSnakbar } from "../../Context/Context-Snakbar/ContextSnackbar";
import Agreement from "./components/Agreement";

function SignAgreement(props) {
  const { showErrorSnak } = useSnakbar();

  const [isLoading, setIsLoading] = useState(true);
  const [documents, setDocuments] = useState({});
  const [requestData, setRequestData] = useState();
  const [agreementStatus, setIsAgreementStatus] = useState("");
  const [amount, setAmount] = useState(null);
  const MakeAgreementDocument = () => {
    let requestObj = {
      path: "/app_api/make_agreement_document",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let postData = {
      request_id: `${props.match.params.requestId}`,
    };
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        GetAgreementDocuments();
      } else {
        //showErrorSnak(res.message);
      }
    });
  };
  const MakeSecondAgreementDocument = () => {
    let requestObj = {
      path: "/app_api/make_second_agreement_document",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let postData = {
      request_id: `${props.match.params.requestId}`,
    };
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        GetAgreementDocuments();
      } else {
        //showErrorSnak(res.message);
      }
    });
  };

  const GetAgreementDocuments = (flag) => {
    let requestObj = {
      path: "/app_api/get_agreement_document",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let postData = {
      request_id: `${props.match.params.requestId}`,
    };

    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        if (flag !== 2) {
          setDocuments(res.request_document);
        }
        setRequestData(res.request_data);
        setIsAgreementStatus(res.agreement_status);
        setIsLoading(false);
        removeElements();
      } else {
        //showErrorSnak(res.message);
      }
    });
  };
  const GetAgreementDocumentsStatus = () => {
    let requestObj = {
      path: "/app_api/get_agreement_document",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let postData = {
      request_id: `${props.match.params.requestId}`,
    };

    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        if (res.agreement_status === 0) {
          MakeAgreementDocument();
        } else {
          GetAgreementDocuments(2);
          console.log(props, "props");
          if (props.location.data) {
            setDocuments(props.location.data.resData);
            setAmount(props.location.data.postData.final_amount);
          } else {
            props.history.goBack();
            // alert();
          }
        }
      } else {
        showErrorSnak(res.message);
      }
    });
  };

  const UploadOnS3 = () => {
    let requestObj = {
      path: "/app_api/upload_agreement_document_ons3",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let postData = {
      request_id: `${props.match.params.requestId}`,
    };

    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        props.history.goBack();
      } else {
        //showErrorSnak(res.message);
      }
    });
  };

  const SendSignaturePDF = (signature) => {
    let requestObj = {
      path: "/app_api/attach_signature_make_pdf",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let postData = {
      request_id: `${props.match.params.requestId}`,
      signature_path: signature,
    };

    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        setTimeout(() => {
          UploadOnS3();
        }, 5000);
      } else {
        //showErrorSnak(res.message);
      }
    });
  };

  const UploadSecondDocumentOnS3 = () => {
    let requestObj = {
      path: "/app_api/upload_second_agreement_document_ons3",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let postData = {
      request_id: `${props.match.params.requestId}`,
    };

    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        props.history.goBack();
        setIsLoading(false);
      } else {
        //showErrorSnak(res.message);
      }
    });
  };

  const SendSecondDocumentSignaturePDF = (signature) => {
    let requestObj = {
      path: "/app_api/attach_second_signature_make_pdf",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let postData = {
      request_id: `${props.match.params.requestId}`,
      signature_path: signature,
      ...props.location.data.postData,
    };

    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        setTimeout(() => {
          UploadSecondDocumentOnS3();
        }, 5000);
      } else {
        //showErrorSnak(res.message);
      }
    });
  };

  const removeElements = () => {
    //remove html elements from DOM by given ids
    // if (!document.getElementById("profile_image")) {
    //   // if given node is not found it means given Ids are already removed.
    //   // so return this function from here
    //   return;
    // }

    // document.getElementById("profile_image").remove();

    document.getElementById("signature_1") &&
      document.getElementById("signature_1").remove();
    document.getElementById("signature_2") &&
      document.getElementById("signature_2").remove();
    document.getElementById("signature_1") &&
      document.getElementById("signature_1").remove();
    document.getElementById("signature_2") &&
      document.getElementById("signature_2").remove();
    document.getElementById("signature_3") &&
      document.getElementById("signature_3").remove();
  };

  useEffect(() => {
    GetAgreementDocumentsStatus();
  }, []);

  if (isLoading) {
    return (
      <>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <p className="small-text-bold page-title ml-2 pt-4">
                <img
                  className="pointer-point"
                  src={blackBackArrowImage}
                  onClick={() => props.history.goBack()}
                />
                <span>Agreement</span>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <section className="main-content address-page">
                <div className="container">
                  <div className="add-items-wrapper">
                    <div className="selected-room ">
                      <div className="row justify-content-center">
                        <div className="Circular-Progress">
                          <CircularProgress />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <p className="small-text-bold page-title ml-2 pt-4">
              <img
                className="pointer-point"
                src={blackBackArrowImage}
                onClick={() => props.history.goBack()}
              />
              <span>Agreement</span>
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <section className="main-content address-page">
              <div className="container">
                <div className="add-items-wrapper">
                  <div className="selected-room ">
                    <div className="row justify-content-center">
                      <div className="col-12">
                        {/*  */}
                        <Agreement
                          documents={documents}
                          SendSignaturePDF={
                            agreementStatus === 0
                              ? SendSignaturePDF
                              : SendSecondDocumentSignaturePDF
                          }
                          showErrorSnak={showErrorSnak}
                          requestData={requestData}
                          agreementStatus={agreementStatus}
                          amount={amount}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default SignAgreement;
